import { createContext, useContext } from 'react'

export interface ContextProps {
  hierarchyTeamIds: number[]
}
export const PeopleChartContext = createContext<ContextProps | null>(null)

export const usePeopleChartContext = (): ContextProps => {
  const context = useContext(PeopleChartContext)
  if (!context) {
    throw new Error('usePeopleChartContext must be within a PeopleChartContextProvider')
  }
  return context
}
